import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import axios from "axios";
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";

import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import styled, { css } from "styled-components";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';




var url = window.location.hostname;
var port = window.location.port;


class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    
    
    this.fetchBinData = this.fetchBinData.bind(this);
    

    this.state = {
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: 'masterFile',
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,

      isLoading: true,
      showFetchBinData: true,
      show_process_data: true,

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',


    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    this.fetchBinData();
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = Util.getCookie('token');
    var location = Util.getCookie('selectedLocation');
    var username = Util.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

    localStorage.setItem('userName', username);
  }

  

 

 

  fetchBinData() {


    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true
    })

      const payload={ 
      location: this.state.selectedLocation,
      }
    API.post("/customer/v1/warehouse/view", { param: payload })
      .then(response => response.data)

      .then(data => {

        this.setState({ posts: data.data })

      })

      .then(async () => {

        this.setState({ tableRows: this.assemblePosts(), isLoading: false })

        console.log(this.state.tableRows);

      });
  }
  assemblePosts = () => {

    let posts = this.state.posts.map((post) => {

      return (

        {

          name: post.name,

          code: post.code,
          warehouse_type: post.warehouse_type,
          address: post.address,
          pincode: post.pincode,
          city: post.city

        }

      )

    });

    this.setState({
      loading_overlay: false
    })

    return posts;

  }

 

  render() {
    console.log(this.state.showInvalidItem)


    const data = {

      columns: [

        {

          label: 'Name',

          field: 'name',
          sort: 'asc',

        },

        {

          label: 'Code',

          field: 'code',
          sort: 'asc',

        },

        {

          label: 'warehouse_type',

          field: 'warehouse_type',
          sort: 'asc',

        },
        {
          label: "Address",
          field: 'address',
          sort: 'asc'
        },
        {
          label: "Pincode",
          field: 'pincode',
          sort: 'asc'
        },
        {
          label: "City",
          field: 'city',
          sort: 'asc'
        }

      ],

      rows: this.state.tableRows,

    }
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>

          {
            this.state.showFetchBinData && (

              <CardBody style={{ marginTop: 20 }}>
                <div className="table_header" style={{ borderBottomWidth: '0px' }}>

                  <h4 style={{ fontWeight: 'bold', width: '80%', paddingTop: 10, float: 'left' }} className="subhead red-text">Warehouse Master</h4>

                  {/* <span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.posts, "RetailorProductMaster")}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span> */}

                </div>
                <hr style={{ marginTop: '30px', marginBottom: '0px' }} />
                <MDBDataTable
                  striped
                  bordered
                  sortable={false}
                  hover
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'warehouse_master_view', 'datatable_pagination_change' )}
                  data={data}
                />
              </CardBody>

            )}

        </Card>

      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));